enum PfmTimePeriodType {
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_12_MONTHS = 'LAST_12_MONTHS',
  PAY_DAY = 'PAY_DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export default PfmTimePeriodType;
